import { c as _c } from "react-compiler-runtime";
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import ComingSoonCover from '@/components/ComingSoonCover';
import { FillScreen } from '@/components/Layout';
import { ScrollableTabsList } from '@/components/Tabs';
import { Tabs, TabsTrigger } from '@/components/ui/tabs';
import { MOCK_ONLY_FEATURE_FLAG } from '@/constants/featureFlags';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
import type { LicenseViolationCategory } from '@/mocks/db/types';
import placeholder from '../_placeholders/-assets/placeholder-alerts.png';
import { AggregatedViolationTable } from './-components/AggregatedViolationTable';
import { useLicenseViolationAlertCounts, useLicenseViolationAlerts } from './-query';
const CATEGORY_VALUES: LicenseViolationCategory[] = ['VIOLATED', 'NO_LICENSE', 'ALUMNI'];
export const Route = createFileRoute('/_staff/licenses/_list/alerts/')({
  component: LicenseAlertsAggregate
});
function LicenseAlertsAggregate() {
  "use memo";

  const $ = _c(36);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.licenses.assignments.tabs"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(defaultNS, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = featureFlags.check(MOCK_ONLY_FEATURE_FLAG);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMockEnabled = t1;
  const [category, setCategory] = useState("VIOLATED");
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      enabled: isMockEnabled
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: counts
  } = useLicenseViolationAlertCounts(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      enabled: isMockEnabled
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data,
    isPending
  } = useLicenseViolationAlerts(category, t3);
  if (!isMockEnabled) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ComingSoonCover placeholderImage={placeholder} />;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("violated");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      value: "VIOLATED",
      label: t4
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("noLicense");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = {
      value: "NO_LICENSE",
      label: t6
    };
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("alumni");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = {
      value: "ALUMNI",
      label: t8
    };
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t5 || $[18] !== t7 || $[19] !== t9) {
    t10 = [t5, t7, t9];
    $[17] = t5;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const tabs = t10;
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = value => setCategory(value as LicenseViolationCategory);
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== counts || $[23] !== tabs) {
    t12 = <ScrollableTabsList className="gap-2 p-0">{tabs.map(tab => <TabsTrigger key={tab.value} value={tab.value} className="h-8 gap-2 data-[state=active]:shadow-none">{tab.label}{counts?.[tab.value] !== undefined && <span className="ml-1 text-xs animate-in fade-in">{counts[tab.value]}</span>}</TabsTrigger>)}</ScrollableTabsList>;
    $[22] = counts;
    $[23] = tabs;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== category || $[26] !== t12) {
    t13 = <Tabs value={category} onValueChange={t11} validValues={CATEGORY_VALUES}>{t12}</Tabs>;
    $[25] = category;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== data) {
    t14 = data ?? [];
    $[28] = data;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isPending || $[31] !== t14) {
    t15 = <div className="min-h-0 flex-1"><AggregatedViolationTable data={t14} isPending={isPending} /></div>;
    $[30] = isPending;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t13 || $[34] !== t15) {
    t16 = <FillScreen className="flex flex-col gap-4 p-10">{t13}{t15}</FillScreen>;
    $[33] = t13;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}